<template>
  <div :id="$route.name">
    <card>
      <template v-slot:header>
        <div class="row">
          <div class="col-10">
            <h4 class="d-inline">{{ title }}</h4>
          </div>
          <div class="col-2">
            <button class="btn btn-warning float-left" @click="returnToCustomer" v-if="PropsCustomer">بازگشت به مشتری</button>
          </div>
          <div class="col-12"><hr /></div>
        </div>
      </template>
      <template v-slot:content>
        <form autocomplete="off">
          <div class="row">
            <div class="col-md-9 col-12">
              <small id="LblTaskSubject">عنوان فعالیت</small>
              <input type="text" class="form-control InputText required" v-model="DataAxios.TaskSubject" :disabled="Isdisabled" />
            </div>
            <div v-if="propsAdd" class="col-md-3 col-12">
              <small id="LblUserId"> ایجاد کننده </small>
              <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserGrpId" :rownumintable="3" :action="'TblCrmCombo/GetUserGrpDatails'" :method="'POST'" :idinput="'UserIdGRP'" :keyItem="'UserIdGRP'" :disabled="Isdisabled" :ClassProps="'required'"> </SearchableCombo>
            </div>
            <div class="col-md-3 col-12">
              <small id="LblGrp14">اولویت</small>
              <SearchableCombo :edit="false" :grp="14" :code="null" @ResultCombo="GetResulGrp14" :rownumintable="3" :defaultvalue="DataAxios.TblComboIdGrp14" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Grp14'" :keyItem="'Grp14'" :disabled="Isdisabled" :ClassProps="'required'">
              </SearchableCombo>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-2 col-12">
              <small id="LblTaskDate"> تاریخ فعالیت</small>
              <date-picker color="dimgray" input-class="required form-control" v-model="DataAxios.TaskDate" clearable :editable="true" placeholder="تاریخ فعالیت" :disabled="Isdisabled" @input="DataAxios.DoneDeadline = $event"></date-picker>
            </div>
            <div class="col-md-2 col-12">
              <small id="LblTaskTime"> زمان فعالیت</small>
              <date-picker color="dimgray" input-class="required form-control" v-model="DataAxios.TaskTime" clearable :editable="true" placeholder="زمان فعالیت" type="time" :disabled="Isdisabled"></date-picker>
            </div>
            <div class="col-md-2 col-12">
              <small id="LblDoneDeadline">مهلت انجام</small>
              <date-picker color="dimgray" :input-class="DataAxios.IsReply ? ' form-control required' : 'form-control'" v-model="DataAxios.DoneDeadline" clearable :editable="true" placeholder="مهلت انجام" :disabled="Isdisabled" :min="DataAxios.TaskDate"></date-picker>
            </div>
            <div class="col-md-3 col-12">
              <small id="LblUserId">ارجاع به </small>
              <SearchableCombo
                :key="keyUserIdTaskCombo"
                :edit="false"
                :grp="0"
                :code="null"
                @ResultCombo="GetResulUserId"
                :rownumintable="3"
                :defaultvalue="DataAxios.TblUserIdTask"
                :action="'TblCrmCombo/GetUserDatails'"
                :method="'POST'"
                :idinput="'UserId'"
                :keyItem="'UserId'"
                :disabled="Isdisabled"
                :ClassProps="'required'"
              >
              </SearchableCombo>
            </div>
            <div class="col-md-3 col-12">
              <small id="LblTblCostomer">مربوط به مشتری</small> <a @click="returnToCustomer" class="text-warning" style="font-size: xx-small">(مشاهده مشتری)</a>
              <SearchableCombo
                :edit="false"
                :grp="0"
                :code="null"
                @ResultCombo="GetResulTblCostomer"
                :rownumintable="3"
                :defaultvalue="PropsCustomer ? PropsCustomer : DataAxios.TblCustomerId"
                :action="'TblCrmCombo/GetCostomer'"
                :method="'POST'"
                :idinput="'TblCostomer'"
                :keyItem="'TblCostomer'"
                :disabled="Isdisabled"
              >
              </SearchableCombo>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-3 col-12">
              <small id="LblIsView">نیاز به پاسخ</small>
              <div class="form-control custom-switch">
                <input type="checkbox" class="form-control-input InputText m-1" id="IsReply" v-model="DataAxios.IsReply" :disabled="$route.params.Status == 'Add' ? false : true" />
                <label class="label txt-bnp mr-2" for="IsReply"> نیاز به پاسخ دارد </label>
              </div>
            </div>
            <div v-if="$route.params.Status == 'Edit'" class="col-md-3 col-12">
              <small id="LblDone"> وضعیت انجام</small>
              <div class="form-control custom-switch">
                <input type="checkbox" class="form-control-input InputText m-1" id="Done" :disabled="DataAxios.Done" v-model="DataAxios.Done" />
                <label class="form-control-label mr-2" for="Done">
                  {{ txtDone }}
                </label>
              </div>
            </div>
            <div v-if="$route.params.Status == 'Edit' && DataAxios.TblUserIdTask == $session.get('UserInfo').tblUserId" class="col-md-6 col-12">
              <small id="LblIsView">وضعیت مشاهده</small>
              <div class="form-control custom-switch">
                <input type="checkbox" class="form-control-input InputText m-1" id="IsView" v-model="DataAxios.IsView" :disabled="DataAxios.Done == true" />
                <label class="label txt-bnp mr-2" for="IsView"> {{ txtIsView }} ({{ DataAxios.DateView }}) </label>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6 col-12">
              <small id="LblTaskDes">توضیحات ایجاد کننده کـار</small>
              <textarea rows="3" type="text" id="TaskDes" class="form-control InputText" v-model="DataAxios.TaskDes" :disabled="Isdisabled"></textarea>
            </div>
            <div class="col-md-6 col-12" v-if="DataAxios.TblUserIdTask == $session.get('UserInfo').tblUserId">
              <small id="LblUserDes">توضیحات دریافت کننده کـار</small>
              <textarea rows="3" type="text" id="TaskDes" class="form-control InputText" v-model="DataAxios.UserDes"></textarea>
            </div>
          </div>
        </form>
        <hr />
        <button v-if="$route.params.Status == 'Add' || propsAdd" class="btn btn-success mr-5" @click.prevent="SaveDeta()">ثبت اطلاعات</button>
        <button v-if="$route.params.Status == 'Edit'" class="btn btn-success mr-5" @click.prevent="SaveEditDeta()">ثبت تغییرات</button>
        <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel()">انصراف</button>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BtnEditData from '@/components/BnpButtons/BtnEditData.vue'
import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  components: { Card, datePicker: VuePersianDatetimePicker, BtnEditData, BtnSaveData, SearchableCombo },
  props: ['PropsCustomer', 'propsAdd', 'fixedTitle'],
  data() {
    return {
      keyUserIdTaskCombo: 0,
      infoTaskStatus: {},
      DataAxiosPost: {
        ArryfildValue: {},
        Method: 'post',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: 'put',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      title: '',
      list: { Id: 1, name: 'ali' },
      DataAxios: { TblComboIdGrp14: 1242, TaskDate: null, TaskTime: null, DoneDeadline: null },
      txtDone: 'این کـار انجام شده',
      Isdisabled: false,
      txtIsView: 'این کـار مشاهده شده',
    }
  },
  created() {
    if (this.propsAdd) {
      this.title = 'اضافه کردن کـار'
      this.DataAxios.TaskSubject = this.fixedTitle
      this.DataAxios.TaskDate = this.$store.state.JalaliDate
      this.DataAxios.TaskTime = this.$store.state.JalaliTime
      this.DataAxios.DoneDeadline = this.$store.state.JalaliDate
    } else if (this.$route.params.Status) {
      if (this.$route.params.Status == 'Add') {
        this.title = 'اضافه کردن کـار'
        this.DataAxios.TaskDate = this.$store.state.JalaliDate
        this.DataAxios.TaskTime = this.$store.state.JalaliTime
        this.DataAxios.DoneDeadline = this.$store.state.JalaliDate
      } else {
        this.title = 'ویـرایـش کـار'
      }
    } else {
      this.$router.push({ name: this.$route.name.substring(6) })
    }
  },
  methods: {
    returnToCustomer() {
      var csutomerId = this.PropsCustomer ? this.PropsCustomer : this.DataAxios.TblCustomerId
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: csutomerId, activeTab: 1 } })
      this.$FindeCustomerById('DetailCustomer', csutomerId, 1, null)
    },
    SaveEditDeta() {
      if (this.DataAxios.IsReply && this.DataAxios.Done) {
        const swalWithBootstrapButtons = this.$swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success mx-1',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })
        swalWithBootstrapButtons
          .fire({
            title: 'عملیات پاسخ به کـار',
            text: 'این کـار نیاز به پاسخ دارد ',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'پاسخ',
            cancelButtonText: 'انصراف',
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$SetLog(this.DataAxios, 0)
              this.DataAxiosUpdate.Action = 'Task'
              this.DataAxiosUpdate.ArryfildValue = this.DataAxios
              this.$PutData_Body(this.DataAxiosUpdate)
                .then((data) => {
                  if (data.status == 'Ok') {
                    this.infoTaskStatus = data.taskStatus
                  } else {
                    if (data.eNum == '2601') {
                      this.$mySweetDefaultTost(false, 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                    }
                  }
                })
                .finally(() => {
                  this.$router.push({ name: 'ReplyTask', params: { Status: 'Add', TaskStatus: this.infoTaskStatus } })
                })
            } else {
              document.getElementById('btnCancel').click()
            }
          })
      } else {
        this.$SetLog(this.DataAxios, 0)
        this.DataAxiosUpdate.Action = 'Task'
        this.DataAxiosUpdate.ArryfildValue = this.DataAxios
        this.$PutData_Body(this.DataAxiosUpdate)
          .then((data) => {
            if (data.status == 'Ok') {
              // this.$mySweetDefaultTost(false, 'تغییرات اطلاعات با موفقیت انجام شد', 'success', 3000)
              if (this.PropsCustomer) {
                this.$toasted.success('فعالیت با موفقیت تغییر یافت', {
                  action: {
                    text: 'بستن',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    },
                  },
                })
                this.returnToCustomer()
              } else {
                document.getElementById('btnCancel').click()
              }
            } else {
              if (data.eNum == '2601') {
                this.$mySweetDefaultTost(false, 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
              }
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false
            this.$store.state.renderComponent = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
              this.$store.state.renderComponent = true
            })
          })
      }
    },
    SaveDeta() {
      if (this.$ValidForm(this.$route.name)) {
        this.DataAxiosPost.Action = 'Task'
        this.DataAxiosPost.ArryfildValue = this.DataAxios
        this.$PostData(this.DataAxiosPost).then((data) => {
          if (data.status == 'Ok') {
            if (this.PropsCustomer) {
              this.$toasted.success('فعالیت با موفقیت ایجاد شد', {
                action: {
                  text: 'بستن',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  },
                },
              })
              if (this.propsAdd) {
                this.$emit('Inserted', {
                  done: 'OK',
                })
              } else {
                this.returnToCustomer()
              }
            } else {
              this.$toasted.success('فعالیت با موفقیت ایجاد شد', {
                action: {
                  text: 'بستن',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  },
                },
              })
              this.Cancel()
            }
          } else {
            if (data.eNum == '2601') {
              this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
            }
            if (data.status == 'Not Ok') {
              if (data.mes != undefined) {
                this.$mySweetDefaultTost('خطایی رخ داده!', data.mes, 'error', 3000)
              } else {
                this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
              }
            }
          }
        })
      }
    },
    Cancel() {
      if (this.PropsCustomer) {
        this.returnToCustomer()
      } else {
        this.$router.go(-1)
      }
    },
    GetResulUserId(data) {
      if (data.id != null) {
        this.DataAxios.TblUserIdTask = data.id
      }
    },
    GetResulTblCostomer(data) {
      if (data.id != null) {
        this.DataAxios.TblCustomerId = data.id
      }
    },
    GetResulGrp14(data) {
      if (data.id != null) {
        this.DataAxios.TblComboIdGrp14 = data.id
      }
    },
    GetResulUserGrpId(data) {
      if (data.id != null) {
        this.DataAxios.TblUserGrpIdInsert = data.id
      }
    },
  },
  mounted() {
    if (this.PropsCustomer) {
      this.DataAxios.TblCustomerId = this.PropsCustomer
    }
    if (this.propsAdd) {
      this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
      if (this.$route.params.DataRow) {
        this.DataAxios = this.$route.params.DataRow
        this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
      }
    } else {
      if (this.$route.params.Status == 'Edit') {
        this.DataAxios = this.$route.params.DataRow
        this.keyUserIdTaskCombo++
        this.DataAxios.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
        this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios)
        this.Isdisabled = this.$session.get('UserInfo').tblUserGrpId == this.DataAxios.TblUserGrpIdInsert ? false : true
      }
      if (this.$route.params.Status == 'Add') {
        this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
        if (this.$route.params.DataRow) {
          this.DataAxios = this.$route.params.DataRow
          this.keyUserIdTaskCombo++

          this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
        }
      }
    }
  },
}
</script>
<style scoped>
.txt-bnp {
  font-size: 11px;
}
</style>
